import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { cddsTitleI18nKey } from '@/lib/cdds-rules'

const STATIC_TITLES: Record<string, string> = {
  '/': 'welcome',
  '/sign-up': 'signUp',
  '/login': 'signIn',
  '/verify-email': 'verifyEmail',
  '/dashboard': 'home',
  '/register/data': 'agreement',
  '/funding': 'funding',
  '/live-account': 'liveAccount',
  '/demo-account': 'demoAccount',
  '/pbk-forms': 'pbk',
  '/funds': 'funds',
}

function titleKeyForPath(pathname: string): string | null {
  if (STATIC_TITLES[pathname]) return STATIC_TITLES[pathname]
  if (pathname === '/register/cdds' || pathname.startsWith('/register/cdds/')) return 'cdds'
  if (pathname.startsWith('/agreement/')) return 'agreement'
  return null
}

/** Sets document.title from regol.pageTitles for the active route. */
export function RegolDocumentTitle() {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  useEffect(() => {
    if (pathname === '/register/cdds' || pathname.startsWith('/register/cdds/')) {
      const code = pathname.replace(/^\/register\/cdds\/?/, '').split('/')[0]
      document.title = code
        ? t(cddsTitleI18nKey(code), { defaultValue: t('regol.pageTitles.cdds') })
        : t('regol.pageTitles.cdds')
      return
    }
    const key = titleKeyForPath(pathname)
    if (!key) return
    document.title = t(`regol.pageTitles.${key}`)
  }, [pathname, t])

  return null
}
